import "../../../styles/admin.css/main-panel-css/admin-dashboard.css";
import { Box } from "@mui/material";
import { useOutletContext } from "react-router-dom";
import { useGetDashboardInfoQuery } from "../../../redux/slices/admin/dashboard/dhSlince.js";
import Loading from "../../../pages/shared/Loading.jsx";
import Error from "../../../pages/shared/Error.jsx";

import Header from "../../../components/dashboard/header/Header.jsx";
import StatBox from "../../../components/dashboard/statbox/StatBox.jsx";
import CategoryChart from "../../../components/dashboard/category-chart/CategoryChart.jsx";
import TopProducts from "../../../components/dashboard/top-products/TopProducts.jsx";
import MonthlyChart from "../../../components/dashboard/monthly-chart/MonthlyChart.jsx";
import Top10Variety from "../../../components/dashboard/top-10-variety/Top10Variety.jsx";
import VpsStats from "../../../components/dashboard/vps-stats/VpsStats.jsx";

import manatIcon from "../../../assets/icon/manat.png";
import returnIcon from "../../../assets/icon/return.png";
import steeringWheelIcon from "../../../assets/icon/steering-wheel.png";

export default function AdminDashboard() {
  const { data: apiResponse, error, isLoading } = useGetDashboardInfoQuery();
  const data = apiResponse?.data || {};
  const { sidebarOpen } = useOutletContext();

  if (isLoading) return <Loading />;
  if (error) return <Error />;

  const brims = ["₼", "₼", "₼", "", "₼", ""];
  const icons = [
    manatIcon,
    manatIcon,
    manatIcon,
    returnIcon,
    manatIcon,
    steeringWheelIcon,
  ];
  const colors = ["#845ADF", "#23B7E5", "#CEC92F", "#4663F5", "#26BF94", "#F5494C"];
  const timePeriods = ["Bu ay", "Bu ay", "Bu gün", "Bu ay", "Bu ay", "Bu ay"];
  const stats = data?.monthlyCart || [];

   
  const routes = [
    { path: "total-earnings", type: "Digər üzrə qazanc" },
    { path: "total-earnings", type: "Digər üzrə qazanc" },
    { path: "total-earnings", type: "Digər üzrə qazanc" },
    { path: "refunded-sales", type: null },
    { path: "total-earnings", type: "Yağ üzrə qazanc" },
    { path: "manage-cars", type: null }
  ];


  return (
    <Box className="admin-dashboard-container">
  
      <Header lastUpdate={data?.updatedAt} />
 
      <div className="dashboard-bottom">
 
        <div className="left-block">
          {stats.map((s, idx) =>
            Object.values(s).map(({ title, value, percent }, i) => {
              const graphData = Array.from({ length: 10 }, () =>
                Math.floor(Math.random() * 100)
              );

              return (
                <StatBox
                  key={`${idx}-${i}`}
                  title={title}
                  value={value}
                  percent={percent}
                  graphData={graphData}
                  color={colors[idx]}
                  icon={icons[idx]}
                  brim={brims[idx]}
                  route={routes[idx]}
                  timePeriod={timePeriods[idx]}
                />

              );
            })
          )}
        </div>
 
        <div className="right-block">
          <CategoryChart data={data?.categoryVariety} />
        </div>
      </div>

      
      <VpsStats vpsStats={data?.vpsStats} />

      <div className="topCC">
        <TopProducts data={data?.topSellingProducts} />
        <Top10Variety data={data?.topVarietyProducts} />
      </div>

    </Box>
  );
}
